module.exports = __webpack_public_path__ + "img/domain.d223274b.png";